"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JarvisTokenExchangeAuthProvider = void 0;
const tslib_1 = require("tslib");
class JarvisTokenExchangeAuthProvider {
    constructor(tokenToExchange, tokenEndpoint, scopes) {
        this.accessToken = '';
        this.tokenToExchange = tokenToExchange;
        this.tokenEndpoint = tokenEndpoint;
        this.scopes = scopes;
    }
    getAccessToken(forceRefresh) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //this.accessToken = this.accessToken || await // Make token exchange grant type call to endpoint to get access token for scopes here
            return this.accessToken;
        });
    }
}
exports.JarvisTokenExchangeAuthProvider = JarvisTokenExchangeAuthProvider;
//# sourceMappingURL=jarvis-token-exchange-auth-provider.js.map